import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'
import { finalize, forkJoin, Subscription, switchMap } from 'rxjs'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { Client } from '../../../shared/client/client'
import { ClientService } from '../../../shared/client/client.service'
import { CommandeParamConfirmModalComponent } from './commande-param-confirm-modal/commande-param-confirm-modal.component'
import { CommandeParamSettingsModalComponent } from './commande-param-settings-modal/commande-param-settings-modal.component'
import { StatisticsModalComponent } from './commande-param-statistics-modal/statistics-modal.component'
import { ActivateLingerieModalComponent } from './lingeries/activate-lingerie-modal/activate-lingerie-modal.component'
import { AddLingerieModalComponent } from './lingeries/add-lingerie-modal/add-lingerie-modal.component'
import { UpdateLingerieModalComponent } from './lingeries/update-lingerie-modal/update-lingerie-modal.component'
import { CommandeSettingsArticles, CommandeSettingsCoeff, CommandeSettingsDeliveries } from './shared/commande-param-settings'
import { CommandeParamSettingsService } from './shared/commande-param-settings.service'
import { Lingerie } from './shared/lingerie'
import { LingerieService } from './shared/lingerie.service'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'

@Component({
  selector: 'app-commande-settings',
  templateUrl: './commande-param-settings.component.html',
  styleUrls: [
    './commande-param-settings.component.scss'
  ]
})
export class CommandeParamSettingsComponent implements OnInit, OnDestroy {

  subClient: Subscription
  public idClient: string
  public client: Client
  public loading: boolean = false
  public loadingDotations: boolean = false
  public saving: boolean = false
  public coef: CommandeSettingsCoeff
  public commandeSettingsDeliveries: CommandeSettingsDeliveries[]
  public commandeSettingsArticles: CommandeSettingsArticles[]
  public commandeSettingsArticlesNotAdded: CommandeSettingsArticles[]
  public commandeSettingsArticlesChanged: CommandeSettingsArticles[] = []
  public commandeSettingsArticlesAll: CommandeSettingsArticles[] = []
  public lingeries: Lingerie[] = []
  public dotations = null
  public currentClient: Client
  public isTmpLingerie

  public commandeSettingsForm = new UntypedFormGroup({
    lundi: new UntypedFormControl({ value: '', disabled: true }),
    mardi: new UntypedFormControl({ value: '', disabled: true }),
    mercredi: new UntypedFormControl({ value: '', disabled: true }),
    jeudi: new UntypedFormControl({ value: '', disabled: true }),
    vendredi: new UntypedFormControl({ value: '', disabled: true }),
    samedi: new UntypedFormControl({ value: '', disabled: true }),
    coef: new UntypedFormControl(''),
    cond: new UntypedFormControl(''),
    cptLingeries: new UntypedFormControl(false),
    cptDotation: new UntypedFormControl(false),
    taux: new UntypedFormControl(false),
    lingerie: new UntypedFormControl(null, [Validators.required]),
    enabledComplement: new UntypedFormControl(false)
  })

  constructor(
    private commandeSettingsService: CommandeParamSettingsService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private notificationService: NotificationService,
    private clientService: ClientService,
    private lingerieService: LingerieService
  ) {
  }
  ngOnInit() {
    this.loading = true
    this.idClient = this.route.snapshot.paramMap.get('id')

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
    })

    this.clientService.getClient(this.idClient).subscribe(value => {
      this.client = value
      this.commandeSettingsForm.get('cptLingeries').setValue(value.is_comptage_lingerie == true ? true : false)
      this.commandeSettingsForm.get('cptDotation').setValue(value.is_comptage_jour == true ? true : false)
      this.commandeSettingsForm.get('taux').setValue(value.enabled_coeff == true ? true : false)
      this.commandeSettingsForm.get('enabledComplement').setValue(value.enabled_complement == true ? true : false)

      this.loading = true
      forkJoin({
        maxOrderRatio: this.commandeSettingsService.getCommandMaxOrderRatio(this.idClient),
        deliveries: this.commandeSettingsService.getCommandDeliveries(this.idClient),
        conditionnement: this.commandeSettingsService.getCommandConditionnement(this.idClient),
        articles: this.commandeSettingsService.getCommandSettingsArticles(this.idClient),
        lingeries: this.lingerieService.getLingeriesClient(this.idClient)
      }).subscribe({
        next: ({ maxOrderRatio, deliveries, conditionnement, articles, lingeries }) => {
          // Récupération des données du back
          this.coef = maxOrderRatio
          this.commandeSettingsDeliveries = deliveries
          this.lingeries = lingeries.sort((a, b) => a.libelle > b.libelle ? 1 : -1)

          // Mise à jour du coefficient
          this.commandeSettingsForm.patchValue({
            coef: (this.coef?.coeff_max_commande * 100).toString()
          })

          // trie des données
          this.commandeSettingsDeliveries.sort(function (a, b) {
            if (a.jrs_relivraison_lp > b.jrs_relivraison_lp) {
              return 1
            } else {
              return -1
            }
          })
          this.formSetData(this.commandeSettingsDeliveries)

          // Mise à jour du conditionnement
          this.commandeSettingsForm.patchValue({
            cond: conditionnement?.enabled_conditionnement ?? false
          })

          // Récupération des articles
          if (!this.commandeSettingsForm.value.cptLingeries && this.client.is_livraison_commande) {
            this.commandeSettingsArticles = articles.filter(obj => { return obj.is_commandable === true })
            this.commandeSettingsArticlesNotAdded = articles.filter(obj => { return obj.is_commandable !== true })
            this.commandeSettingsArticlesAll = articles
          } else {
            this.commandeSettingsArticlesAll = articles
          }

          // Mise en place du trigger quand une lingerie change
          this.commandeSettingsForm.get('lingerie').valueChanges.subscribe((lingerie) => {
            this.loadingDotations = true
            if (lingerie) {
              this.lingerieService.getDotations(lingerie).subscribe((dotations) => {
                this.dotations = dotations

                this.commandeSettingsArticles = this.commandeSettingsArticlesAll.filter(obj => {
                  return this.haveDotation(obj)
                })
                this.commandeSettingsArticlesNotAdded = this.commandeSettingsArticlesAll.filter(obj => {
                  return !this.haveDotation(obj)
                })

                this.setDotations(dotations)
                this.loadingDotations = false
              })
            } else {
              this.loadingDotations = false
            }
          })

          this.loading = false
        }
      })
    })
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  onSubmit() {
    this.saving = true

    let articlesSend = {
      "comptageLingerieChanged": this.client.is_comptage_lingerie != this.commandeSettingsForm.value.cptLingeries,
      "comptageParJourChanged": this.client.is_comptage_jour != this.commandeSettingsForm.value.cptDotation,
      "articles": this.commandeSettingsArticlesChanged
    }

    if (this.client.is_livraison_commande && (articlesSend["comptageLingerieChanged"] || articlesSend["comptageParJourChanged"])) {
      this.loading = false
      const dialogRef = this.dialog.open(CommandeParamConfirmModalComponent, { data: { params: articlesSend, client: this.client } })
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.loading = true
          this.save(articlesSend)
        } else {
          this.saving = false
        }
      }, err => {
        console.log(err)
        this.saving = false
      })
    } else {
      this.save(articlesSend)
    }
  }

  save(articlesSend) {
    this.commandeSettingsDeliveries.forEach((currentValue, index) => {
      switch (currentValue.jrs_relivraison_lp) {
        case 1:
          this.commandeSettingsDeliveries[index].multiple_mab_jour = this.commandeSettingsForm.controls.lundi.value
          break
        case 2:
          this.commandeSettingsDeliveries[index].multiple_mab_jour = this.commandeSettingsForm.controls.mardi.value
          break
        case 3:
          this.commandeSettingsDeliveries[index].multiple_mab_jour = this.commandeSettingsForm.controls.mercredi.value
          break
        case 4:
          this.commandeSettingsDeliveries[index].multiple_mab_jour = this.commandeSettingsForm.controls.jeudi.value
          break
        case 5:
          this.commandeSettingsDeliveries[index].multiple_mab_jour = this.commandeSettingsForm.controls.vendredi.value
          break
        case 6:
          this.commandeSettingsDeliveries[index].multiple_mab_jour = this.commandeSettingsForm.controls.samedi.value
          break
      }
    })

    this.saving = true

    this.commandeSettingsService.patchCommandeSettingsClient(this.idClient, this.commandeSettingsForm.value)
      .pipe(
        switchMap(() =>
          this.commandeSettingsService.patchCommandeSettingsDeliveries(this.idClient, this.commandeSettingsDeliveries)
        ),
        switchMap(() =>
          this.commandeSettingsService.patchCommandSettingsArticlesMultiple(this.idClient, articlesSend)
        ),
        switchMap(() => this.saveMultipleMABConditionnement()),
        finalize(() => this.saving = false)
      )
      .subscribe({
        next: () => {
          // Si le client modifié est celui sélectionné dans la barre
          if (this.currentClient.id == this.client.id) {
            this.client.is_comptage_lingerie = this.commandeSettingsForm.value.cptLingeries
            this.client.is_comptage_jour = this.commandeSettingsForm.value.cptDotation
            this.clientService.selectClient(this.client)
            localStorage.setItem('client', JSON.stringify(this.client))
          }

          this.router.navigate(['/escli/linge-hebergement-param']).then(() => {
            this.notificationService.notif('Les paramètres de commande ont étés enregistrés', 'notif')
          })
        },

        error: (error) => {
          this.saving = false
          console.error(error)
          this.ngOnInit()
        }
      })
  }

  private saveMultipleMABConditionnement() {
    this.coef.coeff_max_commande = this.commandeSettingsForm.controls.coef.value / 100

    return this.commandeSettingsService.putCommandConditionnement(this.idClient,
      {
        enabled_conditionnement: this.commandeSettingsForm.controls.cond.value
      }).pipe(
        switchMap(() =>
          this.commandeSettingsService.putCommandMaxOrderRatio(this.idClient, this.coef)
        )
      )
  }

  private formSetData(commandeSettingsDeliveries: CommandeSettingsDeliveries[]) {
    this.loading = true
    if (this.commandeSettingsDeliveries !== undefined) {
      this.commandeSettingsDeliveries.forEach((currentValue, index) => {
        switch (currentValue.jrs_relivraison_lp) {
          case 1:
            this.commandeSettingsForm.patchValue({
              lundi: typeof currentValue.multiple_mab_jour !== "undefined" ? currentValue.multiple_mab_jour : 0
            })
            this.commandeSettingsForm.get('lundi').enable()
            break
          case 2:
            this.commandeSettingsForm.patchValue({
              mardi: typeof currentValue.multiple_mab_jour !== "undefined" ? currentValue.multiple_mab_jour : 0
            })
            this.commandeSettingsForm.get('mardi').enable()
            break
          case 3:
            this.commandeSettingsForm.patchValue({
              mercredi: typeof currentValue.multiple_mab_jour !== "undefined" ? currentValue.multiple_mab_jour : 0
            })
            this.commandeSettingsForm.get('mercredi').enable()
            break
          case 4:
            this.commandeSettingsForm.patchValue({
              jeudi: typeof currentValue.multiple_mab_jour !== "undefined" ? currentValue.multiple_mab_jour : 0
            })
            this.commandeSettingsForm.get('jeudi').enable()
            break
          case 5:
            this.commandeSettingsForm.patchValue({
              vendredi: typeof currentValue.multiple_mab_jour !== "undefined" ? currentValue.multiple_mab_jour : 0
            })
            this.commandeSettingsForm.get('vendredi').enable()
            break
          case 6:
            this.commandeSettingsForm.patchValue({
              samedi: typeof currentValue.multiple_mab_jour !== "undefined" ? currentValue.multiple_mab_jour : 0
            })
            this.commandeSettingsForm.get('samedi').enable()
            break
        }
      })
    }
    this.loading = false
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CommandeParamSettingsModalComponent, {
      data: { articles: this.commandeSettingsArticlesNotAdded, isLingerie: this.client.is_comptage_lingerie || !this.client.is_livraison_commande }
    })

    dialogRef.afterClosed().subscribe(article => {
      if (typeof article !== "undefined") {
        article.forEach(data => {
          this.addArticle(data, true)
        })
      }
    })
  }

  removeArticle(article: CommandeSettingsArticles, commandable: boolean) {
    this.loading = true
    if (this.isTmpLingerie != false && (this.isTmpLingerie == true || this.client.is_comptage_lingerie || !this.client.is_livraison_commande)) {
      let jours = article.dotations.find(value => value.lingerie == this.commandeSettingsForm.get("lingerie").value)

      if (jours) {
        jours.jours.forEach(element => {
          this.updateArticleDotation(article, { target: { value: 0 } }, element.jour_livraison)
        })
      }
      this.commandeSettingsArticlesNotAdded.push(article)
      this.commandeSettingsArticlesNotAdded.sort((a, b) => a.article.id > b.article.id ? 1 : -1)
      this.commandeSettingsArticles = this.commandeSettingsArticles.filter(art => art != article)
      this.loading = false
    } else {
      this.removeOrAddArticle(article, commandable)
    }
  }

  addArticle(article: CommandeSettingsArticles, commandable: boolean) {
    this.loading = true
    if (this.isTmpLingerie != false && (this.isTmpLingerie == true || this.client.is_comptage_lingerie || !this.client.is_livraison_commande)) {
      this.commandeSettingsArticles.push(article)
      this.commandeSettingsArticles.sort((a, b) => a.article.id > b.article.id ? 1 : -1)
      this.commandeSettingsArticlesNotAdded = this.commandeSettingsArticlesNotAdded.filter(art => art != article)
      this.loading = false
    } else {
      this.removeOrAddArticle(article, commandable)
    }
  }

  removeOrAddArticle(article: CommandeSettingsArticles, commandable: boolean) {
    article.is_commandable = commandable
    this.commandeSettingsService.patchCommandSettingsArticles(this.idClient, article, this.isTmpLingerie).subscribe(
      data => {
        this.getLHClientArticles(this.idClient)
        this.loading = false
      },
      (error) => {
        this.loading = false
      })
  }

  updateArticleConditionnement(article: CommandeSettingsArticles, event) {
    article.qte_conditionnement = +event.target.value
    this.commandeSettingsArticlesChanged.push(article)
  }

  isCondActive() {
    return this.commandeSettingsForm.value.cond == '1' || this.commandeSettingsForm.value.cond == true
  }

  ajoutLingerie() {
    const dialogRef = this.dialog.open(AddLingerieModalComponent, { data: this.client })
    dialogRef.beforeClosed().subscribe(result => {
      if (result) {
        this.getLHClientLingeries(this.idClient)
      }
    }, err => console.log(err), () => {
    })
  }

  activateLingeries() {
    const dialogRef = this.dialog.open(ActivateLingerieModalComponent, { data: this.client })
    dialogRef.beforeClosed().subscribe(result => {
      if (result) {
        this.getLHClientLingeries(this.idClient)
        this.commandeSettingsForm.get("lingerie").setValue(null)
        this.dotations = null
      }
    }, err => console.log(err), () => {
    })
  }

  updateLingerie() {
    let currentLingerie = this.lingeries.find(x => x.id === this.commandeSettingsForm.value.lingerie)
    const dialogRef = this.dialog.open(UpdateLingerieModalComponent, { data: { client: this.client, lingerie: currentLingerie } })
    dialogRef.beforeClosed().subscribe(result => {
      if (result) {
        this.getLHClientLingeries(this.idClient)
        if (result.activated) {
          this.commandeSettingsForm.get("lingerie").setValue(result.id)
        } else {
          this.dotations = null
          this.commandeSettingsForm.get("lingerie").setValue(null)
        }
      }
    }, err => console.log(err), () => {
    })
  }

  getLHClientLingeries(id: string) {
    this.loading = true
    this.lingerieService.getLingeriesClient(id).subscribe(data => {
      this.lingeries = data.sort((a, b) => a.libelle > b.libelle ? 1 : -1)
      this.loading = false
    })
  }

  haveDotation(article) {
    const articleId = article.article.id
    const lingerie = this.commandeSettingsForm.value.lingerie
    const changeArticle = this.commandeSettingsArticlesChanged.find(art => art.article.id === articleId);
    const changeLingerie = changeArticle?.dotations?.find(val => val.lingerie === lingerie)

    for (let jour = 0; jour < 7; jour++) {
      const dotationChange = changeLingerie?.jours?.find(val => val.jour_livraison === jour)
      if (dotationChange?.quantite > 0) return true

      const dotationJour = this.dotations.find(val => val.jour_livraison === jour)
      const dotationArticle = dotationJour?.dotations?.find(val => val.article.id === articleId)
      if (dotationArticle?.quantite > 0) return true
    }

    return false
  }

  setDotations(dotations) {
    const lingerie = this.commandeSettingsForm.value.lingerie

    this.commandeSettingsArticles.forEach(article => {
      if (!article.dotations || article.dotations.findIndex(x => x.lingerie === lingerie) == -1) {
        let jours = []
        dotations.forEach(value => {
          const dotation = value.dotations.find(art => art.article.id === article.article.id)
          
          if (dotation) {
            jours.push({ jour_livraison: value.jour_livraison, quantite: dotation.quantite })
          }
        })

        article.dotations ??= []
        article.dotations.push({ lingerie, jours })
      }
    })
  }

  updateArticleDotation(article: CommandeSettingsArticles, event, jour_semaine) {
    let value = +event.target.value
    if (value < 0 || !value) {
      if (value < 0) this.notificationService.notif("Quantité saisie inférieure à 0, mise à 0", 'warn')
      event.target.value = 0
      value = 0
    }

    let dotation = article.dotations?.find(x => x.lingerie === this.commandeSettingsForm.value.lingerie)
    if (!dotation) {
      dotation = { lingerie: this.commandeSettingsForm.value.lingerie, jours: [] }
      article.dotations?.push(dotation)
    }

    let jour = dotation.jours.find(x => x.jour_livraison === jour_semaine)
    if (!jour) {
      dotation.jours.push({ jour_livraison: jour_semaine, quantite: value })
    } else {
      jour.quantite = value
    }

    const alreadyChanged = this.commandeSettingsArticlesChanged.some(
      art => art.id === article.id
    )

    if (!alreadyChanged) {
      this.commandeSettingsArticlesChanged.push(article)
    }
  }

  getDotation(article, jour_semaine) {
    if (!article.dotations) {
      this.setDotations(this.dotations)
    }

    const dotation = article.dotations?.find(dotation => dotation.lingerie === this.commandeSettingsForm.value.lingerie)
    const jour = dotation?.jours.find(jour => jour.jour_livraison === jour_semaine)

    return jour?.quantite ?? null;
  }

  getJourLivraison(delivery) {
    switch (delivery.jrs_relivraison_lp) {
      case 1: return "Lundi"
      case 2: return "Mardi"
      case 3: return "Mercredi"
      case 4: return "Jeudi"
      case 5: return "Vendredi"
      case 6: return "Samedi"
      default: return "Unknow"
    }
  }

  onChangeComptage() {
    this.commandeSettingsArticlesChanged = []
    if (!this.commandeSettingsForm.value.cptLingeries) {
      this.getLHClientArticles(this.idClient)
      this.commandeSettingsForm.get('cptDotation').setValue(false)
      this.commandeSettingsForm.get('lingerie').setValue(null)
      this.dotations = null
      this.isTmpLingerie = false
    } else {
      this.isTmpLingerie = true
      this.getLHClientArticlesLingeries(this.idClient)
    }
  }

  getLHClientArticles(id: string) {
    this.loading = true
    this.commandeSettingsService.getCommandSettingsArticles(id).subscribe(data => {
      this.commandeSettingsArticles = data.filter(obj => { return obj.is_commandable === true })
      this.commandeSettingsArticlesNotAdded = data.filter(obj => { return obj.is_commandable !== true })
      this.commandeSettingsArticlesAll = data
      this.loading = false
    })
  }

  getLHClientArticlesLingeries(id: string) {
    this.loading = true
    this.commandeSettingsService.getCommandSettingsArticles(id).subscribe(data => {
      this.commandeSettingsArticlesAll = data
      this.loading = false
    })
  }

  onChangeComptageJour() {
    this.commandeSettingsArticlesChanged = []
  }

  checkValue(event, index) {
    if (event.target.value < 0) {
      event.target.value = 0
      this.commandeSettingsForm.controls[index].setValue(0)
    }
  }

  selectionChange(event: MatAutocompleteSelectedEvent) {
    const article = this.commandeSettingsArticlesAll.find(art => art.id === event.option.value)

    if (article) {
      article.enabled_statistics = event.option.selected
    }
  }

  statistics() {
    this.dialog.open(StatisticsModalComponent, { data: this.commandeSettingsArticlesAll })
  }
}
